export const HELP_LINK = "https://luxhome.ai/pages/help"

/** The Luxedo custom shows storefront. The store moved from luxedo.com to luxhome.ai. */
export const CUSTOM_SHOWS_LINK = "https://luxhome.ai/collections/custom-shows"
